import React from 'react';
import './Product.css';

import { Link } from 'react-router-dom';



const Product = ({ product, list }) => {

  // Destructuring product properties
  const { image, content, name, price, demoLink } = product;

  return ( 

    <div className='product-item'>

      <div className='image'>
  
        <img src={image} alt={name} /> {/* Product image */}

      </div>
 
      <div className='content'>

        {/* Product Name Link */}
        <Link
          to={{
            pathname: '/Shop/' + name,
          }}
          location={{ product }}
          state={product}><h3>{name}</h3> {/* Product name */}
        </Link> 

        {/* Product Description (conditionally rendered) */}
        {list && <p>{content}</p>} 

        {/* Discounted price and original price */}
        <div className='price'>
          <p>${price}</p>
        </div>

        <div className='btn-container'>
          {/* View Product Details Button */}
<a 
  href={demoLink} 
  target="_blank" 
  rel="noopener noreferrer" 
  className="btn"
>
  Live Demo
</a>

          {/* View Product Details Button */}
          <Link to={`/Shop/${name}`} state={product} className='btn'>
            Learn More
          </Link>
        </div>



        

      </div>

    </div>
  );
};

export default Product;